<template>
    <div class="block--small">
        <h2>
            {{$t('notfound.header')}}
        </h2>
        <p>
            <router-link :to="{ name: 'home' }" class="button--cta">
                {{$t('notfound.link_go_back')}}
            </router-link>
        </p>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';

    @Component
    export default class PageNotFound extends Vue {
        name = 'page-not-found';
    }
</script>



// WEBPACK FOOTER //
// src/pages/PageNotFound.vue